'use client';

import { useTranslations } from 'next-intl';
import { LABEL_CLASS, LABEL_MUTED_CLASS, NOTE_MAX } from '../constants';

interface NoteFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function NoteField({ value, onChange }: NoteFieldProps) {
  const tf = useTranslations('priceAlerts.form');

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span className={LABEL_CLASS}>{tf('note')}</span>
        <span className={LABEL_MUTED_CLASS}>{tf('noteOptional')}</span>
      </div>
      <div className="flex flex-col gap-1.5">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.slice(0, NOTE_MAX))}
          placeholder={tf('notePlaceholder')}
          maxLength={NOTE_MAX}
          className="h-11 rounded-[10px] bg-v2-btn-secondary px-4 text-[13px] leading-[150%] font-normal text-v2-text-primary outline-none placeholder:text-v2-text-secondary focus:ring-1 focus:ring-v2-border"
        />
        <span className="text-[12px] leading-[115%] font-normal text-v2-text-secondary">
          {value.length}/{NOTE_MAX}
        </span>
      </div>
    </div>
  );
}
